import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_product_purchases_summary,
    getReportLabel: () => t`Product Purchase Summary`,
    getColumns: () => [],
};
